<div class="container">
    <true-breadcrumbs [subset]="this.config.subset" [assessmentName]="assessmentName + ' (' + assessmentObject + ')'"></true-breadcrumbs>
    <h1>Node Selection</h1>
    <p>Choose the specific nodes in your value chain where you would like to perform a sustainability assessment. Focus your assessment on the areas most relevant to your business goals and sustainability objectives.</p>

    <ul>
        <li *ngFor="let node of nodesEnabled">
            <img [src]="'assets/icons/nodes/'+node.icon" />
            <span>{{node.name}}</span>
            <input type="checkbox" [(ngModel)]="node.enabled" (ngModelChange)="setNodeSelection()" />
        </li>
    </ul>
    <div *ngIf="error" class="error">{{errorMessage}}</div>
    <div class="btn right" (click)="next()">NEXT STEP</div>
</div>